import { render, staticRenderFns } from "./EditCrmCustomer.vue?vue&type=template&id=641ef9fc"
import script from "./EditCrmCustomer.vue?vue&type=script&lang=js"
export * from "./EditCrmCustomer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports